import React from "react";
import logo from "../images/mb-m-500-white.png";

export default function Footer() {
  return (
    <footer className="bg-primary-animated text-gray-100 py-20 lg:py-24 px-8">
      <div className="max-w-screen-xl mx-auto flex flex-col items-center">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <img src={logo} alt="" className="w-8" />
          <span className="text-2xl font-black tracking-wider">Metabetta</span>
        </div>

        {/* Links */}
        <nav className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-2">
          <a href="/" className="border-b-2 border-transparent hover:text-gray-300 hover:border-gray-300 pb-1 transition">
            Home
          </a>
          <a href="/#about" className="border-b-2 border-transparent hover:text-gray-300 hover:border-gray-300 pb-1 transition">
            About
          </a>
          <a href="/#contact" className="border-b-2 border-transparent hover:text-gray-300 hover:border-gray-300 pb-1 transition">
            Contact Us
          </a>
          <a href="/blog" className="border-b-2 border-transparent hover:text-gray-300 hover:border-gray-300 pb-1 transition">
            Blog
          </a>
        </nav>

        {/* Social */}
        <div className="mt-10 flex gap-4">
          <a href="https://twitter.com/metabettadotcom" className="text-gray-100 hover:text-gray-400 transition" aria-label="Twitter">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
            </svg>
          </a>
          <a href="https://www.linkedin.com/company/metabetta" className="text-gray-100 hover:text-gray-400 transition" aria-label="LinkedIn">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
        </div>

        {/* Copyright */}
        <p className="mt-10 text-sm text-gray-100 tracking-wide">
          &copy; Copyright 2020-2026, Metabetta. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
